<template lang="html">
  <v-flex
    shrink
    pa-0
  >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="400"
      style="width: 100%;"
      scrollable
    >
      <template #activator="{ on }">
        <span
          style="cursor:pointer"
          v-on="on"
        >
          <!-- <v-flex xs12 pa-0 > -->
          <slot
            v-if="hasActivator && !hideActivator"
            name="activator"
          />

          <v-btn
            v-if="!hasActivator && !hideActivator"
            text
            icon
            :color="color"
          >
            <v-icon>{{ activatorIcon }}</v-icon>
          </v-btn>
        <!-- </v-flex> -->
        </span>
      </template>

      <v-card class="grey lighten-4">
        <v-card-title class="headline error white--text">
          <v-icon class="white--text mr-2">
            warning
          </v-icon>{{ title }}
        </v-card-title>
        <v-card-text>
          <v-layout
            v-if="imageSrc && dialog"
            justify-center
          >
            <v-img
              :src="imageSrc"
              max-height="400"
              max-width="400"
              contain
            />
          </v-layout>
          <v-layout
            align-content-center
            align-center
            mt-3
          >
            <v-flex
              v-if="icon"
              align-content-center
              align-center
              pr-2
            >
              <v-icon :color="iconColor">
                {{ icon }}
              </v-icon>
            </v-flex>
            <v-flex
              v-if="message"
              xs12
              align-content-center
              align-center
              v-html="message"
            />
          </v-layout>
          <v-layout wrap>
            <v-flex
              v-if="nbText"
              mt-2
            >
              <div
                class="caption"
                v-html="nbText"
              />
            </v-flex>
            <v-flex
              v-if="challenge"
              xs12
              mt-4
            >
              {{ challengeText }} <strong>{{ challenge }}</strong>
              <v-text-field
                id="id"
                ref="input"
                v-model="challengeCapture"
                class="mt-2"
                color="error"
                solo
                text
                flat
                label="Type text"
                @keydown.enter="confirmDelete()"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click.native="dialog = false"
          >
            {{ cancelButtonText }}
          </v-btn>
          <v-btn
            color="error"
            text
            :disabled="challenge && !challengePass"
            @click.native="confirmDelete()"
          >
            {{ deleteButtonText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
export default {
  props: {
    value: Boolean,
    color: {
      default: ''
    },
    title: {
      type: String,
      default: 'Delete?'
    },
    icon: {
      type: String,
      default: undefined
    },
    iconColor: {
      type: String,
      default: 'grey'
    },
    activatorIcon: {
      type: String,
      default: 'delete'
    },
    message: {
      type: String,
      default: ''
    },
    deleteButtonText: {
      type: String,
      default: 'Delete'
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel'
    },
    nbText: {
      type: String,
      default: ''
    },
    challenge: {
      type: String,
      default: undefined
    },
    challengeText: {
      type: String,
      default: 'To delete type'
    },
    imageSrc: String,
    hideActivator: Boolean,
    bypassPrompt: Boolean
  },
  data () {
    return {
      dialog: false,
      challengeCapture: ''
    }
  },
  computed: {
    hasActivator () {
      return !!this.$slots.activator || !!this.$scopedSlots.activator
    },
    challengePass () {
      return this.challenge === this.challengeCapture
    }
  },
  watch: {
    dialog (v) {
      if (this.bypassPrompt) {
        this.dialog = false
        this.$emit('delete')
      }
      this.$emit('input', v)
      if (this.challenge) {
        requestAnimationFrame(() => {
          this.$refs.input.focus()
          this.challengeCapture = ''
        })
      }
    },
    value (v) {
      this.dialog = v
    }
  },
  methods: {
    show () {
      this.dialog = true
    },
    confirmDelete () {
      if (this.challenge) {
        if (this.challenge !== this.challengeCapture) return
      }
      this.$emit('delete')
      this.dialog = false
    }
  }
}
</script>

<style>
</style>
